import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import citiesReducer from "./features/citySlice";
import truckGroupsReducer from "./features/truckGroupSlice";
import trucksReducer from "./features/truckSlice";
import retiredTrucksReducer from "./features/retiredTruckSlice";
import truckHistoriesReducer from "./features/truckHistorySlice";
import trucksInGroupReducer from "./features/trucksInGroupSlice";
import appStateReducer from "./features/appStateSlice";
import allTrucksReducer from "./features/allTrucksSlice";
import vendorsReducer from "./features/vendorSlice";
import customersReducer from "./features/customerSlice";
import operationsTeamsReducer from "./features/operationsTeamSlice";
import ordersReducer from "./features/orderSlice";
import standbyOrdersReducer from "./features/standbyOrderSlice";
import uangJalanReportsReducer from "./features/uangJalanReportSlice";
import suratJalanReducer from "./features/suratJalanSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    cities: citiesReducer,
    truckGroups: truckGroupsReducer,
    trucks: trucksReducer,
    retiredTrucks: retiredTrucksReducer,
    truckHistories: truckHistoriesReducer,
    trucksInGroup: trucksInGroupReducer,
    appState: appStateReducer,
    allTrucks: allTrucksReducer,
    vendors: vendorsReducer,
    customers: customersReducer,
    operationsTeams: operationsTeamsReducer,
    orders: ordersReducer,
    standbyOrders: standbyOrdersReducer,
    uangJalanReports: uangJalanReportsReducer,
    suratJalan: suratJalanReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
